if (!customElements.get('product-badges')) {
  class ProductBadges extends HTMLElement {
    constructor() {
      super();
      this.badgeContainers = this.querySelectorAll('.js-badge-container');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.badgeContainers) {
        // Bind to on:variant:change event for this product
        const productContainer = this.closest('.product');
        if (productContainer) {
          const variantPicker = productContainer.querySelector('variant-picker');
          if (variantPicker) {
            variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
          }
        }

        // Set initial badges based on current variant
        this.setVisibleBadges(this.dataset.currentVariantId);
      }
    }

    /**
     * Sets the visible badges based on variant id.
     * @param {string} variantId - The variant id
     */
    setVisibleBadges(variantId) {
      this.badgeContainers.forEach((container) => {
        container.hidden = container.dataset.variantId.toString() !== variantId.toString();
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleBadges(evt.detail.variant.id);
      }
    }
  }

  customElements.define('product-badges', ProductBadges);
}

